import { useProject } from '@/hooks'
import { useParams } from 'react-router-dom'

export function AutomationPage() {
  const { projectId } = useParams()
  const { data: project } = useProject(projectId)

  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm text-foreground font-medium">Project: {project?.name ?? 'Loading...'}</p>
        <h1 className="text-3xl font-bold">Automation</h1>
      </div>
    </div>
  )
}
